import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Cache from 'i18next-localstorage-cache'
import resources from '@logdna-web/i18n/resources'
import i18nFormat from '@logdna-web/i18n/i18nFormat'

i18n
  .use(Cache)
  .use(LanguageDetector)
  .init({
    interpolation: {
      escapeValue: false,
      format: i18nFormat
    },
    resources,
    fallbackLng: 'en'
  })

export const setNamespace = keys => (value, options = {}) => {
  return i18n.t(value, { ns: [...keys], ...options }) || value
}

export const translate = (path, options) => {
  const [namespace, ...rest] = path.split('.')
  const t = setNamespace([namespace])
  return t(rest.join('.'), options)
}

export default i18n

